import { UserInput } from 'src/modules/user-input/types.ts';
import { ValvesPageVariables } from 'src/modules/valves/ValvesPageMapping.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { getUnitByName } from 'src/modules/user-input/getUnitByName.ts';
import { TargetUnits } from 'src/modules/user-input/targetUnits.ts';
import { calcMinDnSteam } from 'src/modules/user-input/calcVolumetricFlow/calcKvsSteam.ts';

type ComposedValveVariables = Omit<ValvesPageVariables, 'limit' | 'offset' | 'locale' | 'filter'>;

export const composeValveVariables = (
    userInput: UserInput,
    targetUnits: TargetUnits,
): ComposedValveVariables => ({
    kvs: userInput.kvs.length > 0 ? convert(
        userInput.kvs,
        getUnitByName(userInput.kvs_u, targetUnits.volumetricFlow),
        targetUnits.volumetricFlow,
    ) : '',
    kvs2: userInput.kvs_2.length > 0 ? convert(
        userInput.kvs_2,
        getUnitByName(userInput.kvs_2_u, targetUnits.volumetricFlow),
        targetUnits.volumetricFlow,
    ) : '',
    volumetricFlow: userInput.v100.length > 0 ? convert(
        userInput.v100,
        getUnitByName(userInput.v100_u, targetUnits.volumetricFlow),
        targetUnits.volumetricFlow,
    ) : '',
    volumetricFlow2: userInput.v100_2.length > 0 ? convert(
        userInput.v100_2,
        getUnitByName(userInput.v100_2_u, targetUnits.volumetricFlow),
        targetUnits.volumetricFlow,
    ) : '',
    minDN: userInput.outlet.length > 0 && userInput.mass.length > 0 ? calcMinDnSteam(
        convert(
            userInput.mass,
            getUnitByName(userInput.mass_u, targetUnits.massVolumetricFlow),
            targetUnits.massVolumetricFlow,
        ),
        convert(
            userInput.outlet,
            getUnitByName(userInput.outlet_u, targetUnits.inletOutlet),
            targetUnits.inletOutlet,
        ),
    ) : '',
});
